/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path context
 * @description Application context
 */
import React from "react";
import { AppLevelContext } from "./AppCtx";
import { getDefaultPeriod } from "./periodDefaults";
type StateSelector<T extends AppLevelContext, U> = (state: T) => U;
export type UseContextStore<T extends AppLevelContext> = {
  (): T;
  <U>(selector: StateSelector<T, U>): U;
};
export const AppContext = React.createContext<AppLevelContext>({
  editMode: false,
  appBarVisible: true,
  language: "en",
  rtl: false,
  period: getDefaultPeriod(),
  originalPeriod: getDefaultPeriod(),
  networkErrors: [],
  pageAnchors: [],
  modelId: "",
  fullModelId: "",
  serverURL: process.env.REACT_APP_SERVER_URL,
  sendValue: () => {},
  lastSearchUpdateTime: Date.now(),
});
const useAppContextFn = (
  fn?: (ctx: AppLevelContext) => AppLevelContext[keyof AppLevelContext]
) => {
  const ctx = React.useContext(AppContext);
  if (!fn) {
    return ctx;
  }
  return fn(ctx);
};
export const useAppContextHook: UseContextStore<AppLevelContext> =
  useAppContextFn as any;
